import React from 'react';
import './Loader.css';

interface ILoaderProps {
    isLoading: boolean;
}

const Loader = (props: ILoaderProps) => 
            <div className={props.isLoading ? "visible" : "hidden"}>
                <div className="ball">
                </div>
                <p className="loader-text">LOADING</p>
            </div>;

export default Loader;